"use client";

import * as React from "react";
import * as Popover from "@radix-ui/react-popover";
import { Drawer } from "vaul";
import { useAppLauncherContext } from "../providers/app-launcher-provider";
import type { AppLauncherTriggerStyle } from "../types";
import { DotsGridIcon } from "./icons";
import { TrackingBoundary } from "../../../lib/sentry/index";

export interface AppLauncherTriggerProps {
  asChild?: boolean;
  children?: React.ReactNode;
  /** Additional CSS class merged with built-in `.al-trigger-btn` (default trigger only) */
  className?: string;
  /** Inline style + CSS custom property overrides (`AppLauncherTriggerStyle`) — default trigger only */
  style?: AppLauncherTriggerStyle;
}

export function AppLauncherTrigger({
  asChild,
  children,
  className,
  style,
}: AppLauncherTriggerProps) {
  const { isMobile, theme } = useAppLauncherContext();

  const hasChildren = children != null;
  const shouldAsChild = asChild ?? true;
  const classes = className ? `al-trigger-btn ${className}` : "al-trigger-btn";

  const triggerContent = hasChildren ? (
    children
  ) : (
    <button
      type="button"
      className={classes}
      data-theme={theme}
      data-track="open"
      style={style}
    >
      <DotsGridIcon size={18} />
    </button>
  );

  if (isMobile) {
    return (
      <TrackingBoundary feature="app_launcher">
        <Drawer.Trigger asChild={shouldAsChild}>{triggerContent}</Drawer.Trigger>
      </TrackingBoundary>
    );
  }

  return (
    <TrackingBoundary feature="app_launcher">
      <Popover.Trigger asChild={shouldAsChild}>{triggerContent}</Popover.Trigger>
    </TrackingBoundary>
  );
}
